import type { ProgramNode } from "./AstNode"
import type { CalcScriptConceptCollection } from "./ConceptCollector"
import { Token } from "./Token"

export const CalcType = {
	Value: 'value',
	Validation: 'validation',
	Activation: 'activation',
} as const

export type CalcType = typeof CalcType[keyof typeof CalcType]

export interface CompiledCalcScript {
	calcType: CalcType
	concepts: CalcScriptConceptCollection
	programNode: ProgramNode
}

export interface CalcScriptCompileError {
	area: string
	message: string
	line?: number
	column?: number
}

export const CalcScriptCompileErrorMsgs = {
	UnexpectedStatement: (value: Token['value']) => `Unexpected statement '${value}'`,
	CalcTypeNotInferredByReturn: () => 'Calculation type not inferred by RETURN',
	ReturnStatementInferredChangedCalcType: (prev: CalcType, next: CalcType) => 
		`RETURN statement inferred calculation type '${next}', but type '${prev}' was previously inferred`,
	VariableNotDeclared: (name: string) => `Variable '${name}' is not declared`,
	MultiDimensionalArray: () => 'Multi-dimensional arrays are not supported',
} as const
